import type React from 'react';

import { useGetDepartments } from '@vlabs/api/artemy/client';
import type { PermissionTag } from '@vlabs/api/artemy/model';
import { useHasPermission } from '@vlabs/permissions';

import { DepartmentListItem } from '@vlabs/monokit/entities/departments/';

import { FoldableEntity } from '@vlabs/monokit/shared/ui/foldable-entity';

import { usePermissionTagDepartmentListInfoTranslation } from './i18n';
import st from './PermissionTagDepartmentListInfo.module.sass';

interface PermissionTagDepartmentListInfoProps {
  permissionTag: PermissionTag;
}

function PermissionTagDepartmentListInfo({
  permissionTag,
}: PermissionTagDepartmentListInfoProps): React.JSX.Element {
  const { t } = usePermissionTagDepartmentListInfoTranslation();
  const canViewDepartments = useHasPermission('departments', 'read');
  const { data } = useGetDepartments({ permission_tag: permissionTag, page_size: 1000 });

  if (!canViewDepartments) return null;

  const departmentsCount = data?.departments?.length ?? 0;

  return (
    <FoldableEntity heading={t('title')}>
      <div className={st.Departments}>
        <div className={st.Subtitle}>{t('subtitle', { count: departmentsCount })}</div>
        <div className={st.List}>
          {data?.departments?.map((d) => {
            const departmentId = d.department_id;
            if (departmentId) {
              return (
                <DepartmentListItem
                  departmentId={departmentId}
                  key={d.department_id}
                />
              );
            }
            return null;
          })}
        </div>
      </div>
    </FoldableEntity>
  );
}

export { PermissionTagDepartmentListInfo };
